import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getMenosTalentosThunk } from "../../../store/reducers/dashboard/menosTalentos/menosTalentos.thunks";
import RankingTable from "./RankingTable";

const RANK_COLORS = [
  "text-danger-600",
  "text-danger-600",
  "text-warning-600",
  "text-secondary-light",
  "text-secondary-light",
];

const POPOVERS = {
  promedio: (
    <>
      Indica la posición promedio que ocupa este talento en el total
      de evaluaciones realizadas.
      <br />
      <strong>
        Un valor más alto significa menor predominancia dentro del grupo evaluado.
      </strong>
    </>
  ),
  top1: (
    <>
      Número de veces que este talento ocupó el primer lugar
      entre todas las evaluaciones.
      <br />
      En este grupo suele ser menos frecuente en las primeras posiciones.
    </>
  ),
};

const CardMenosTalentos = () => {
  const dispatch = useDispatch();
  const { menosTalentos, loading, error } = useSelector(
    (state) => state.menosTalentos
  );
  const { escuela, plantel } = useSelector((state) => state.dashboardFilters);

  useEffect(() => {
    dispatch(getMenosTalentosThunk());
  }, [dispatch, escuela, plantel]);

  return (
    <RankingTable
      title="Top 5 Talentos a Mejorar"
      icon="solar:danger-bold"
      iconColor="text-danger-600"
      data={menosTalentos}
      loading={loading}
      error={error}
      popovers={POPOVERS}
      rankColors={RANK_COLORS}
    />
  );
};

export default CardMenosTalentos;
